import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../../../components/form/form-field';
import SaveButton from '../../../../../components/form/save-button';
import { useNodeContext } from '../../../../../context/node-context';

const DirectoryListTaskForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id: _id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="directoryListTaskFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="directoryListTaskFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="directoryListTaskFormFunction"
        label="function"
        name="function"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.function?.message}
        defaultValue="directoryList"
      />
      <FormField
        controlId="directoryListTaskFormCredentials"
        label="credentials"
        name="parameters.credentials"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter credentials"
        error={errors.parameters?.credentials?.message}
      />
      <FormField
        controlId="directoryListTaskFormPort"
        label="port"
        name="parameters.port"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter port"
        error={errors.parameters?.port?.message}
      />
      <FormField
        controlId="directoryListTaskFormDirPath"
        label="dirPath"
        name="parameters.dirPath"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter directory path"
        error={errors.parameters?.dirPath?.message}
      />
      <FormField
        controlId="directoryListTaskFormFilter"
        label="filter"
        name="parameters.filter"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter filter"
        error={errors.parameters?.filter?.message}
      />
      <FormField
        controlId="directoryListTaskFormOutput"
        label="output"
        name="parameters.output"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter output"
        required
        error={errors.parameters?.output?.message}
      />
      <FormField
        controlId="directoryListTaskFormResult"
        label="result"
        name="parameters.result"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter result"
        required
        error={errors.parameters?.result?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default DirectoryListTaskForm;
